import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router";
import API from "../../../services";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { faChevronLeft, faCopy } from "@fortawesome/free-solid-svg-icons";
import React from "react";
import { useTranslation } from "../../../hooks/useTranslation";

interface TransactionHistoryItemProps { }


const BetDetails: React.FC<TransactionHistoryItemProps> = () => {
    const { t } = useTranslation();
    const location = useLocation();
    const [newTicket, setNewTicket] = useState<any>(false);
    const [loading, setLoading] = useState(false);
    const [newTicDes, setNewTicDes] = useState<any>("");
    const [newTicCat, setNewTicCat] = useState<any>("");
    const { details } = location.state || {};
    const navigate = useNavigate()
    const dateFormat = (time: number) => {
        const matchStartTime = new Date(time);
        const formattedStartTime = matchStartTime.toLocaleString("en-GB", {
            day: "numeric",
            month: "numeric",
            year: "numeric",
            hour: "numeric",
            minute: "numeric",
            second: "numeric",
            hour12: false,
        });
        return { formatted: formattedStartTime };
    };

    const [selectedImages, setSelectedImages] = useState<File[]>([]);
    const [previews, setPreviews] = useState<string[]>([]);
    const [loadSubmit, setLoadSubmit] = useState<any>(false);
    const fileInputRef = useRef<HTMLInputElement | null>(null);


    useEffect(() => {
        let cat = details?.category === "CASINO" ? details?.category : "SPORTS";
        setNewTicCat(cat);
    }, []);


    const handleBackClick = () => {
        navigate(-1);
    };

    const handleTicketsuccess = () => {
        navigate("/ticket-details", { state: { ticketId: details?.ticketId } });
    };

    const handleWithDrawSubmit = async (event: React.FormEvent) => {
        event.preventDefault();

        setLoadSubmit(true);

        const fileToBase64 = (file: File): Promise<string> => {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = () => {
                    const result = reader.result as string;
                    const base64 = result.includes(",") ? result.split(",")[1] : result;
                    resolve(base64);
                };
                reader.onerror = (error) => reject(error);
                reader.readAsDataURL(file);
            });
        };

        try {
            const images = await Promise.all(selectedImages.map((image) => fileToBase64(image)));
            const image_names = selectedImages.map((image) => image.name);
            const image_types = selectedImages.map((image) => image.type);

            const payload = {
                category: details?.category,
                description: newTicDes,
                referenceID: details?.betId
            };

            const formData = new FormData();
            formData.append("ticketData", JSON.stringify(payload));

            if (images.length > 0) {
                formData.append("image", images.join(","));
                formData.append("image_names", image_names.join(","));
                formData.append("image_types", image_types.join(","));
            }

            const response = await API.post(`/webapp/create-support-ticket`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            const data = response.data;
            if (data?.status !== "RS_OK") {
                toast.error(`${data.errorDescription}`);
                return;
            } else {
                toast.success(t("support.messages.ticketUpdatedSuccessfully"));
                navigate("/customersupport");
            }
            setNewTicDes("");
            setNewTicket(false);

        } catch (error) {
            console.error("There was a problem with the fetch operation:", error);
        } finally {
            setLoadSubmit(false);
        }
    };

    const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {

        if (!e.target.files || e.target.files.length === 0) {
            console.log("No files selected"); // Debugging
            return;
        }

        const files = Array.from(e.target.files);

        const validFiles = files.filter(file => file.size < 1024 * 1024); // Ensure size < 1MB
        if (validFiles.length === 0) {
            toast.info(t("support.messages.onlyImagesLessThan1MBAllowed"));
            return;
        }

        setSelectedImages((prevImages) => [...prevImages, ...validFiles]);
        setPreviews((prevPreviews) => [
            ...prevPreviews,
            ...validFiles.map((file) => URL.createObjectURL(file)),
        ]);

        // Fix: Reinitialize file input to ensure event triggers on next selection
        resetFileInput();
    };

    const resetFileInput = () => {
        if (fileInputRef.current) {
            fileInputRef.current.value = "";
            const newInput = fileInputRef.current.cloneNode(true) as HTMLInputElement;
            fileInputRef.current.replaceWith(newInput);
            fileInputRef.current = newInput;

            // Fix: Wrap handleImageChange inside an event listener conversion
            fileInputRef.current.addEventListener("change", (evt) => {
                handleImageChange(evt as unknown as React.ChangeEvent<HTMLInputElement>);
            });
        }
    };

    const removeImage = (index: number) => {
        setSelectedImages((prevImages) => prevImages.filter((_, i) => i !== index));
        setPreviews((prevPreviews) => prevPreviews.filter((_, i) => i !== index));
    };

    if (!details) {
        return <div>{t("bets.messages.noDetailsAvailable")}</div>;
    }

    const profitLossAmount = details?.walletType === "REWARD"
        ? details?.rewardNetAmount
        : details?.netAmout;

    return (
        <>
            <div className="flex flex-col px-3 mt-4 w-full pb-[7rem] py-[4rem] transaction-history">
                <header className="relative flex items-center text-base font-medium text-white mb-[0.5rem] w-full">
                    <div>
                        <div className="bg-inputbox-color flex p-1 mr-[0.25rem] rounded"
                            onClick={() => handleBackClick()}
                        >
                            <ArrowBackIcon
                                className="text-border-color aspect-square w-[18px]"
                                style={{ width: '20px', height: '20px' }}
                            />
                        </div>
                    </div>
                    <h2 className="flex-grow">{t("bets.betDetails")}</h2>
                    {
                        details?.ticketId !== "" ? (
                            <button
                                onClick={() => handleTicketsuccess()}
                                className="absolute right-0 px-3 py-2 text-xs font-medium text-white whitespace-nowrap rounded-lg border border-solid bg-inputbox-color border-slate-800"
                            >
                                <span>{t("support.viewTicket")}</span>
                            </button>
                        ) : (
                            <button
                                onClick={() => setNewTicket(true)}
                                className="absolute right-0 px-3 py-2 text-xs font-medium text-white whitespace-nowrap rounded-lg border border-solid bg-inputbox-color border-slate-800"
                            >
                                <span>{t("support.newTicket")}</span>
                            </button>
                        )
                    }
                </header>
                <div className="p-2">
                    <div className="mb-2">
                        <p className="text-base font-medium text-white">{t("bets.betIdLabel")}</p>
                        <div className="p-1 flex items-center space-x-2">
                            <p className="text-sm text-white">{details?.betId}</p>
                            <button
                                onClick={() => {
                                    navigator.clipboard.writeText(details?.betId || "");
                                }}
                                className="px-2 py-1 text-xs text-white bg-primary-color rounded hover:bg-primary-dark transition flex items-center space-x-1"
                            >
                                <FontAwesomeIcon icon={faCopy} className="text-white" />

                            </button>
                        </div>
                    </div>
                    <div className="mb-2">
                        <p className="text-base font-medium text-white">{t("bets.category")}</p>
                        <div className="p-1">
                            <p className="text-sm text-white">{details?.category}</p>
                        </div>
                    </div>

                    <div className="mb-2">
                        <p className="text-base font-medium text-white">{t("bets.status")}</p>
                        <div className="p-1">
                            <p className="text-sm text-white">{details?.status}</p>
                        </div>
                    </div>

                    <div className="mb-2">
                        <p className="text-base font-medium text-white">{t("bets.time")}</p>
                        <div className="p-1">
                            <p className="text-sm text-white">{dateFormat(details?.betTime)?.formatted}</p>
                        </div>
                    </div>

                    <div className="mb-2">
                        <p className="text-base font-medium text-white">{t("bets.netAmount")}</p>
                        <div className="p-1">
                            <p className="text-sm text-white">{(profitLossAmount ?? 0).toFixed(2)}</p>
                        </div>
                    </div>
                    <div className="mb-2">
                        <p className="text-base font-medium text-white">{t("common.points")}</p>
                        <div className="p-1">
                            <p className="text-sm text-white">{details?.points}</p>
                        </div>
                    </div>

                    <div className="mb-2">
                        <p className="text-base font-medium text-white">{t("common.playChips")}</p>
                        <div className="p-1">
                            <p className="text-sm text-white">{details?.playChips}</p>
                        </div>
                    </div>

                    <div className="mb-2">
                        <p className="text-base font-medium text-white">{t("common.reward")}</p>
                        <div className="p-1">
                            <p className="text-sm text-white">{details?.reward}</p>
                        </div>
                    </div>


                    {details?.sportName && (
                        <div className="mb-4">
                            <p className="text-base font-medium text-white">{t("bets.sport")}</p>
                            <div className="p-1">
                                <p className="text-sm  text-white">{details?.sportName}</p>
                            </div>
                        </div>
                    )}

                    {details?.eventName && (
                        <div className="mb-4">
                            <p className="text-base font-medium text-white">{t("bets.eventName")}</p>
                            <div className="p-1">
                                <p className="text-sm  text-white">{details?.eventName}</p>
                            </div>
                        </div>
                    )}

                    {details?.marketName && (
                        <div className="mb-4">
                            <p className="text-base font-medium text-white">{t("bets.marketName")}</p>
                            <div className="p-1">
                                <p className="text-sm  text-white">{details?.marketName}</p>
                            </div>
                        </div>
                    )}

                    {details?.betType && (
                        <div className="mb-4">
                            <p className="text-base font-medium text-white">{t("bets.betType")}</p>
                            <div className="p-1">
                                <p className="text-sm  text-white">{details?.betType}</p>
                            </div>
                        </div>
                    )}

                    {details?.runnerName && (
                        <div className="mb-4">
                            <p className="text-base font-medium text-white">{t("bets.runnerName")}</p>
                            <div className="p-1">
                                <p className="text-sm  text-white">{details?.runnerName}</p>
                            </div>
                        </div>
                    )}

                        {details?.oddValue && (
                            <div className="mb-4">
                                <p className="text-base font-medium text-white">{t("bets.oddValue")}</p>
                                <div className="p-1">
                                    <p className="text-sm  text-white">{details?.oddValue}</p>
                                </div>
                            </div>
                        )}

                        {details?.marketType && (
                            <div className="mb-4">
                                <p className="text-base font-medium text-white">{t("bets.marketType")}</p>
                                <div className="p-1">
                                    <p className="text-sm  text-white">{details?.marketType}</p>
                                </div>
                            </div>
                        )}



                </div>
            </div>
            {
                newTicket && (
                    <Dialog
                        fullScreen={false}
                        open={newTicket}
                        onClose={() => { setNewTicket(false); setNewTicDes("") }}
                        PaperProps={{
                            style: {
                                position: 'absolute',
                                top: '5rem'
                            }
                        }}
                    >
                        <div className="h-dialog-bg bg-inputbox-color relative p-4">
                            <CloseIcon
                                className="absolute top-3 right-3 text-white text-2xl font-semibold"
                                onClick={() => setNewTicket(false)}
                            />
                            <div>
                                <div>
                                    {t("support.createNewTicket")}
                                </div>
                                <div>
                                    <>
                                        <form className="flex flex-col w-full" onSubmit={handleWithDrawSubmit}>
                                            <label
                                                htmlFor="amount"
                                                className="block mt-2 text-sm text-zinc-400"
                                            >
                                                {t("support.description")}
                                            </label>
                                            <input
                                                type="text"
                                                className="px-4 py-3 mt-2.5 w-full text-sm font-medium text-white placeholder:text-text-color whitespace-nowrap rounded-lg border border-solid bg-inputbox-color border-border-color focus:outline-none leading-[1.4rem]"
                                                placeholder={t("support.enterYourIssue")}
                                                value={newTicDes || ""}
                                                onChange={(e) => setNewTicDes(e.target.value)}
                                            />

                                            <div>
                                                <label className="block mt-3 text-sm text-zinc-400">{t("support.attachImage")}</label>
                                                <label className="block w-full mt-2 mb-2">
                                                    <input
                                                        id="file-upload"
                                                        ref={fileInputRef}
                                                        type="file"
                                                        accept="image/*"
                                                        // multiple
                                                        onChange={handleImageChange}
                                                        className="hidden"
                                                    />
                                                    <button
                                                        type="button"
                                                        onClick={() => fileInputRef.current?.click()}
                                                        className="flex items-center justify-center w-full px-4 py-3 text-sm font-medium text-white whitespace-nowrap rounded-lg border border-solid bg-inputbox-color border-border-color shadow-sm hover:bg-opacity-80"
                                                    >
                                                        {t("support.chooseImage")}
                                                    </button>
                                                </label>
                                                <label className="block text-xs text-zinc-400">{t("support.onlyImagesLessThan1MB")}</label>
                                                <label className="block text-xs text-zinc-400">{t("support.noteIfUnableToUpload")}</label>

                                                {previews.length > 0 && (
                                                    <div className="grid grid-cols-3 gap-4 mt-2">
                                                        {previews.map((preview, index) => (
                                                            <div key={index} className="relative group">
                                                                <img
                                                                    src={preview}
                                                                    alt={`Preview ${index}`}
                                                                    className="w-24 h-24 object-cover rounded-lg border border-border-color shadow-md"
                                                                />
                                                                <button
                                                                    onClick={() => removeImage(index)}
                                                                    className="absolute top-1 right-1 bg-red-600 text-white rounded-full w-5 h-5 text-xs flex items-center justify-center opacity-90 hover:opacity-100 transition"
                                                                >
                                                                    ✕
                                                                </button>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>

                                            <div className="flex justify-between mt-4">
                                                <button
                                                    type="submit"
                                                    className="p-2.5 w-[48%] text-sm text-white bg-border-color rounded-lg border border-border-color border-solid leading-[1.4rem]"
                                                    disabled={!newTicDes || loadSubmit}
                                                >
                                                    {loadSubmit ? t("support.submitting") : t("common.submit")}
                                                </button>
                                                <button
                                                    type="button"
                                                    className="p-2.5 w-[48%] text-sm text-white bg-error-color rounded-lg border border-error-color border-solid leading-[1.4rem]"
                                                    onClick={() => { setNewTicket(false) }}
                                                >
                                                    {t("common.cancel")}
                                                </button>
                                            </div>
                                        </form>
                                    </>
                                </div>
                            </div>
                        </div>
                    </Dialog>
                )
            }
        </>
    );
};


export default BetDetails;
